import {
  useCreateAccountReceivable,
  useGetAccountReceivable,
} from 'api-hooks/account-receivable';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import AccountReceivableForm from './components/form';

export type AccountReceivableViewParams = {
  id: string;
};

export default function AccountReceivableView(
  props: NavigationProps<NavigationRoutes.AccountReceivablesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetAccountReceivable({
      id,
    });
  const { mutateAsync, error: errorMutate } = useCreateAccountReceivable();

  const accountReceivable = data?.data;

  const onResolve = useApprovalableEdit('account-receivables');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <AccountReceivableForm
            {...props}
            accountReceivable={accountReceivable}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
